// Inlined replacement for vuex-router-sync (v6 is rc-only on npm).
// Behavior-identical port of its sync(): exposes the current route as
// store.state.route and keeps it updated on navigation, with devtools
// time-travel support (store -> router).
export function sync(store: any, router: any, options?: { moduleName?: string }) {
  const moduleName = options?.moduleName ?? 'route'

  store.registerModule(moduleName, {
    namespaced: true,
    state: cloneRoute(router.currentRoute.value),
    mutations: {
      ROUTE_CHANGED(_s: any, t: any) {
        store.state[moduleName] = cloneRoute(t.to, t.from)
      },
    },
  })

  let isTimeTraveling = false
  let currentPath: string | undefined

  // store -> router (devtools time travel)
  store.watch(
    (state: any) => state[moduleName],
    (route: any) => {
      if (route.fullPath === currentPath) {
        return
      }
      if (currentPath != null) {
        isTimeTraveling = true
        router.push(route)
      }
      currentPath = route.fullPath
    },
    { flush: 'sync' }
  )

  // router -> store
  router.afterEach((to: any, from: any) => {
    if (isTimeTraveling) {
      isTimeTraveling = false
      return
    }
    currentPath = to.fullPath
    store.commit(`${moduleName}/ROUTE_CHANGED`, { to, from })
  })
}

function cloneRoute(to: any, from?: any) {
  const clone: any = {
    name: to.name,
    path: to.path,
    hash: to.hash,
    query: to.query,
    params: to.params,
    fullPath: to.fullPath,
    meta: to.meta,
  }
  if (from) {
    clone.from = cloneRoute(from)
  }
  return Object.freeze(clone)
}
